/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';

function MailingTab(props) {
  const { invoiceDetailsByInvoiceNum } = props;
  return (
    <div className='tabs-container'>
      <div className='invoice_details outline_auto_height'>
        <div className='form-wrapper'>
          <div className='mui-custom-form with-select input-md'>
            <TextField
              id='manufacturer_id'
              label='Manufacturer Id'
              fullWidth
              placeholder=''
              disabled
              value={invoiceDetailsByInvoiceNum?.mfgId}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                maxLength: 10,
              }}
            />
          </div>
          <div className='mui-custom-form with-select input-md'>
            <TextField
              id='manufacturer_name'
              label='Manufacturer Name'
              fullWidth
              placeholder=''
              value={invoiceDetailsByInvoiceNum?.mfgName}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                maxLength: 10,
              }}
            />
          </div>
        </div>
        <fieldset className='custom-fieldset custom-fieldset-margin'>
          <legend>Contact Information</legend>
          <div className='form-wrapper'>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='name'
                label='Name'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.contactName}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='corporation_name'
                label='Corporation Name'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.corpName}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='address_line1'
                label='Address Line 1'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.addrLine1}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          <div className='form-wrapper'>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='address_line2'
                label='Address Line 2'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.addrLine2}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='address_line3'
                label='Address Line 3'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.addrLine3}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='city'
                label='City'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.city}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          <div className='form-wrapper'>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='state'
                label='State'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.stateCd}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='zip'
                label='Zip'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.zip}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className='mui-custom-form with-select input-md'>
              <TextField
                id='zip4'
                label='Zip+4'
                fullWidth
                placeholder=''
                value={invoiceDetailsByInvoiceNum?.phoneNum}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className='form-wrapper'>
              <div className='mui-custom-form with-select input-md'>
                <TextField
                  id='phone_number'
                  label='Phone Number'
                  fullWidth
                  placeholder=''
                  value={invoiceDetailsByInvoiceNum?.zip4}
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className='mui-custom-form with-select input-md'>
                <TextField
                  id='extension'
                  label='Extension'
                  fullWidth
                  placeholder=''
                  value={invoiceDetailsByInvoiceNum?.phoneExtension}
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className='mui-custom-form with-select input-md'>
                <TextField
                  id='fax_number'
                  label='Fax Number'
                  fullWidth
                  placeholder=''
                  value={invoiceDetailsByInvoiceNum?.faxNum}
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            <div className='form-wrapper'>
              <div className='mui-custom-form with-select input-md'>
                <TextField
                  id='email_address'
                  label='Email Address'
                  fullWidth
                  placeholder=''
                  value={invoiceDetailsByInvoiceNum?.email}
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  );
}
export default withRouter(MailingTab);
